// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"203":"05d8a70013d77dad","725":"aeffc084f1b46f69","735":"2398a1d47374c769","867":"97cdc43cc83c05c8"}[chunkId] + ".js";
};